module.exports = __webpack_public_path__ + "img/NL560.d037aa11.png";